// Import the edliy_utils
import {
    makeResponsive,
    placeTitle,
    placeImage,
    placeInput,
    placeSlider,
    hoverMe,
    placeRec,
    hiddenPt,
    fixedPt,
    clearInputFields,
    dragMe,
    placeArrow,
    placeGravity,
    placeText,
    placeLine,
    placePoint,
    placeGlider,
    placeRuler,
    placeLeftText,
    placeSliderSwitch
} from '../../../common/edliy_utils-integral';
const Boxes = {
box1: function () {
JXG.Options.point.showInfoBox=false;
JXG.Options.point.highlight=false;
JXG.Options.text.highlight=false;
JXG.Options.text.fixed=true;
JXG.Options.curve.highlight=false;
JXG.Options.polygon.highlight=false;
JXG.Options.text.cssDefaultStyle='fontFamily:Oswald;'
var brd1 = JXG.JSXGraph.initBoard('jxgbox1',{boundingbox: [-1, 16, 16, -1],
    keepaspectratio: true, axis:true, ticks:{visible:false},
    grid:true, showCopyright:false, showNavigation:false,
    pan:{enabled:false}, zoom:{enabled:false}});
brd1.options.layer['image']=14;
brd1.suspendUpdate();
//Title
makeResponsive(brd1);
placeTitle(brd1, 'Area of a Triangle');
//Sliders
//Variables
var size_cat = 1;
var size_buttons = 0.5;

var tx = 2;
var ty = 12;

var tx2 = 2;
var ty2 = 10;

var sizeOk = 0.5;
var inpX = tx2 + 10;
var inpY =ty2;

let switchStatus = true;

//Switch
let switch3 = brd1.create('text', [12.5,14,'<label class="switch" ><input type="checkbox"><span class="slider"></span></label>'], {fixed: true});

//Points of images
var ptA = brd1.create('point', [6,6],{snapToGrid: true, face:'o' , name:'A (x_A, y_A)', fillColor: '#5B43FF', strokeColor: 'black', size:3, withLabel:true, fixed:false, visible:true, label:{highlightStrokeColor: '#FF3B3B', offset: [-40, 40], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
var ptB = brd1.create('point', [2,3],{snapToGrid: true, face:'o' , name:'B (x_B, y_B)', size:3, fillColor: '#5B43FF', strokeColor: 'black', withLabel:true, fixed:false, visible:true, label:{highlightStrokeColor: '#FF3B3B', offset: [-2, 40], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
var ptC = brd1.create('point', [8,4],{snapToGrid: true, face:'o' , name:'C (x_C, y_C)', size:3, fillColor: '#5B43FF', strokeColor: 'black', withLabel:true, fixed:false, visible:true, label:{highlightStrokeColor: '#FF3B3B', offset: [-2, 40], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});

var ptQ = brd1.create('point', [function(){return ptB.X()}, 0], {face:'o' , name:'Q', size:3, fillColor: '#5B43FF', strokeColor: 'black', withLabel:true, fixed:true, visible:true, label:{offset: [5, -25], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
var ptP = brd1.create('point', [function(){return ptA.X()}, 0], {face:'o' , name:'P', size:3, fillColor: '#5B43FF', strokeColor: 'black', withLabel:true, fixed:true, visible:true, label:{offset: [5, -25], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
var ptR = brd1.create('point', [function(){return ptC.X()}, 0], {face:'o' , name:'R', size:3, fillColor: '#5B43FF', strokeColor: 'black', withLabel:true, fixed:true, visible:true, label:{offset: [5, -25], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});

//Polygons
var polABQP = brd1.create('polygon', [ptA, ptB, ptQ, ptP], {fixed: true, visible: true, highlightFillColor: '#5B43FF', vertices:{visible:false, fixed:true}, borders:{fixed: true, visible:true, strokeColor: '#5B43FF', strokeWidth: 1.5, dash: 3, highlightStrokeColor: '#5B43FF'}, fillColor: 'white', fillOpacity:0.5});
var polAPRC = brd1.create('polygon', [ptA, ptP, ptR, ptC], {fixed: true, visible: true, highlightFillColor: '#5B43FF', vertices:{visible:false, fixed:true}, borders:{fixed: true, visible:true, strokeColor: '#5B43FF', strokeWidth: 1.5, dash: 3, highlightStrokeColor: '#5B43FF'}, fillColor: 'white', fillOpacity:0.5});
var polBQRC = brd1.create('polygon', [ptB, ptQ, ptR, ptC], {fixed: true, visible: true, highlightFillColor: '#5B43FF', vertices:{visible:false, fixed:true}, borders:{fixed: true, visible:true, strokeColor: '#5B43FF', strokeWidth: 1.5, dash: 3, highlightStrokeColor: '#5B43FF'}, fillColor: 'white', fillOpacity:0.5});
var polABC = brd1.create('polygon', [ptA, ptB, ptC], {fixed: true, visible: true, highlightFillColor: '#5B43FF', vertices:{visible:false, fixed:true}, borders:{fixed: true, visible:true, strokeColor: '#5B43FF', strokeWidth: 4, highlightStrokeColor: '#5B43FF'}, fillColor: 'white', fillOpacity:0.5});

//Text
var txtABC = brd1.create('text', [tx, ty  , 'Area of &#9651; ABC'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx + 1.5, ty  , '='],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtABQP = brd1.create('text', [tx + 3.2, ty  , 'Area of ⏢ ABQP'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx + 5, ty  , '+'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtAPRC = brd1.create('text', [tx + 6.8, ty  , 'Area of ⏢ APRC'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx + 8.5, ty  , '-'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtBQRC = brd1.create('text', [tx + 10.3, ty  , 'Area of ⏢ BQRC'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

//Area formula
var txtABC2 = brd1.create('text', [tx2, ty2  , 'Area of &#9651; ABC'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 1.5, ty2  , '='],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 2, ty2  , '0.5'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 2.5, ty2  , '['],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

var txtXA = brd1.create('text', [tx2 + 2.8, ty2  , 'x_A'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 3.1, ty2  , '('],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtYB = brd1.create('text', [tx2 + 3.4, ty2  , 'y_B'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 3.7, ty2  , '-'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtYC = brd1.create('text', [tx2 + 4.0, ty2  , 'y_C'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 4.3, ty2  , ')'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 4.7, ty2  , '+'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

var txtXB = brd1.create('text', [tx2 + 5.1, ty2  , 'x_B'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 5.4, ty2  , '('],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtYC2 = brd1.create('text', [tx2 + 5.7, ty2  , 'y_C'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 6.0, ty2  , '-'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtYA = brd1.create('text', [tx2 + 6.3, ty2  , 'y_A'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 6.6, ty2  , ')'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 7.0, ty2  , '+'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

var txtXC = brd1.create('text', [tx2 + 7.4, ty2  , 'x_C'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 7.7, ty2  , '('],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtYA2 = brd1.create('text', [tx2 + 8.0, ty2  , 'y_A'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 8.3, ty2  , '-'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtYB2 = brd1.create('text', [tx2 + 8.6, ty2  , 'y_B'],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 8.9, ty2  , ')'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 9.2, ty2  , ']'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txt = brd1.create('text', [tx2 + 9.6, ty2  , '='],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var txtMove = brd1.create('text', [tx2 + 10.5, ty2  , function(){return Math.abs(areaOfTriangle().toFixed(2));}],{highlightStrokeColor: '#FF3B3B',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

//Inputs
var input_sth = brd1.create('input', [50,50, '', ''], {fixed: true, cssStyle: 'fontFamily:Oswald; width:7%; background-color:#C1C1C1;border: 1px solid black;border-radius: 3.5px;', fontSize:function(){return Math.round(12*brd1.canvasWidth/500.)}, fixed:true,parse:true});

//Images
var ok1 = brd1.create('image', ['assets/check.svg', [50,50], [sizeOk, sizeOk]], {visible: function(){if(input_sth.Value() == areaOfTriangle().toFixed(2)){return true}else{return false;}}, fixed: true});
var cross1 = brd1.create('text', [50,50 , 'Try Again!'], {visible: function(){if(input_sth.Value() == areaOfTriangle().toFixed(2) || input_sth.Value() == ''){return false}else{return true;}}, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd1.canvasWidth/500.)}},);

//Functions
function areaOfTriangle(){
    return 0.5*( ptA.X() * (ptB.Y() - ptC.Y()) + ptB.X() * (ptC.Y() - ptA.Y()) + ptC.X() * (ptA.Y() - ptB.Y()) )
}

function test_mode(){
    txtMove.setAttribute({visible: false});
    ok1.moveTo([inpX + sizeOk/2, inpY - sizeOk - 0.5], 10);
    cross1.moveTo([inpX, inpY - 0.5], 10);
    input_sth.moveTo([inpX,inpY], 10);
}

function learn_mode(){
    txtMove.setAttribute({visible: true});
    ok1.moveTo([50,50], 10);
    cross1.moveTo([50,50], 10);
    input_sth.moveTo([50,50], 10);
    input_sth.set('');
}

function switchToggle(){

    if (switchStatus == false) {
      switchStatus = true;
      learn_mode();
        }
    else {
        switchStatus = false;
        test_mode();
      }
}

//Mouse Click
switch3.on('down', function(){return switchToggle()});

//Hover text for polygons ABC
txtABC.on('over', function () {
    polABC.setAttribute({visible: true, fillColor: '#FF3B3B'});
});

txtABC.on('out', function () {
    polABC.setAttribute({visible: true, fillColor: '#fff'});
});

txtABC2.on('over', function () {
    polABC.setAttribute({visible: true, fillColor: '#FF3B3B'});
});

txtABC2.on('out', function () {
    polABC.setAttribute({visible: true, fillColor: '#fff'});
});

txtMove.on('over', function () {
    polABC.setAttribute({visible: true, fillColor: '#FF3B3B'});
});

txtMove.on('out', function () {
    polABC.setAttribute({visible: true, fillColor: '#fff'});
});

//Hover text for polygons ABQP
txtABQP.on('over', function () {
    polABQP.setAttribute({visible: true, fillColor: 'red'});
});

txtABQP.on('out', function () {
    polABQP.setAttribute({visible: true, fillColor: 'red'});
});

//Hover text for polygons APRC
txtAPRC.on('over', function () {
    polAPRC.setAttribute({visible: true, fillColor: 'red'});
});

txtAPRC.on('out', function () {
    polAPRC.setAttribute({visible: true, fillColor: 'red'});
});

//Hover text for polygons BQRC
txtBQRC.on('over', function () {
    polBQRC.setAttribute({visible: true, fillColor: 'white', fillOpacity:1});
});

txtBQRC.on('out', function () {
    polBQRC.setAttribute({visible: true, fillColor: 'white'});
});

//Hover labels of points
ptA.label.on('over', function () {
    txtXA.setAttribute({strokeColor: '#FF3B3B'});
    txtYA.setAttribute({strokeColor: '#FF3B3B'});
    txtYA2.setAttribute({strokeColor: '#FF3B3B'});
});

ptA.label.on('out', function () {
    txtXA.setAttribute({strokeColor: '#000'});
    txtYA.setAttribute({strokeColor: '#000'});
    txtYA2.setAttribute({strokeColor: '#000'});
});

ptB.label.on('over', function () {
    txtXB.setAttribute({strokeColor: '#FF3B3B'});
    txtYB.setAttribute({strokeColor: '#FF3B3B'});
    txtYB2.setAttribute({strokeColor: '#FF3B3B'});
});

ptB.label.on('out', function () {
    txtXB.setAttribute({strokeColor: '#000'});
    txtYB.setAttribute({strokeColor: '#000'});
    txtYB2.setAttribute({strokeColor: '#000'});
});

ptC.label.on('over', function () {
    txtXC.setAttribute({strokeColor: '#FF3B3B'});
    txtYC.setAttribute({strokeColor: '#FF3B3B'});
    txtYC2.setAttribute({strokeColor: '#FF3B3B'});
});

ptC.label.on('out', function () {
    txtXC.setAttribute({strokeColor: '#000'});
    txtYC.setAttribute({strokeColor: '#000'});
    txtYC2.setAttribute({strokeColor: '#000'});
});

//Hover text on equation point A
txtXA.on('over', function () {
    txtYA.setAttribute({strokeColor: '#FF3B3B'});
    txtYA2.setAttribute({strokeColor: '#FF3B3B'});
    ptA.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtXA.on('out', function () {
    txtYA.setAttribute({strokeColor: '#000'});
    txtYA2.setAttribute({strokeColor: '#000'});
    ptA.label.setAttribute({strokeColor: '#000'});
});

txtYA.on('over', function () {
    txtXA.setAttribute({strokeColor: '#FF3B3B'});
    txtYA2.setAttribute({strokeColor: '#FF3B3B'});
    ptA.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtYA.on('out', function () {
    txtXA.setAttribute({strokeColor: '#000'});
    txtYA2.setAttribute({strokeColor: '#000'});
    ptA.label.setAttribute({strokeColor: '#000'});
});

txtYA2.on('over', function () {
    txtXA.setAttribute({strokeColor: '#FF3B3B'});
    txtYA.setAttribute({strokeColor: '#FF3B3B'});
    ptA.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtYA2.on('out', function () {
    txtXA.setAttribute({strokeColor: '#000'});
    txtYA.setAttribute({strokeColor: '#000'});
    ptA.label.setAttribute({strokeColor: '#000'});
});

//Hover text on equation point B
txtXB.on('over', function () {
    txtYB.setAttribute({strokeColor: '#FF3B3B'});
    txtYB2.setAttribute({strokeColor: '#FF3B3B'});
    ptB.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtXB.on('out', function () {
    txtYB.setAttribute({strokeColor: '#000'});
    txtYB2.setAttribute({strokeColor: '#000'});
    ptB.label.setAttribute({strokeColor: '#000'});
});

txtYB.on('over', function () {
    txtXB.setAttribute({strokeColor: '#FF3B3B'});
    txtYB2.setAttribute({strokeColor: '#FF3B3B'});
    ptB.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtYB.on('out', function () {
    txtXB.setAttribute({strokeColor: '#000'});
    txtYB2.setAttribute({strokeColor: '#000'});
    ptB.label.setAttribute({strokeColor: '#000'});
});

txtYB2.on('over', function () {
    txtXB.setAttribute({strokeColor: '#FF3B3B'});
    txtYB.setAttribute({strokeColor: '#FF3B3B'});
    ptB.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtYB2.on('out', function () {
    txtXB.setAttribute({strokeColor: '#000'});
    txtYB.setAttribute({strokeColor: '#000'});
    ptB.label.setAttribute({strokeColor: '#000'});
});

//Hover text on equation point C
txtXC.on('over', function () {
    txtYC.setAttribute({strokeColor: '#FF3B3B'});
    txtYC2.setAttribute({strokeColor: '#FF3B3B'});
    ptC.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtXC.on('out', function () {
    txtYC.setAttribute({strokeColor: '#000'});
    txtYC2.setAttribute({strokeColor: '#000'});
    ptC.label.setAttribute({strokeColor: '#000'});
});

txtYC.on('over', function () {
    txtXC.setAttribute({strokeColor: '#FF3B3B'});
    txtYC2.setAttribute({strokeColor: '#FF3B3B'});
    ptC.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtYC.on('out', function () {
    txtXC.setAttribute({strokeColor: '#000'});
    txtYC2.setAttribute({strokeColor: '#000'});
    ptC.label.setAttribute({strokeColor: '#000'});
});

txtYC2.on('over', function () {
    txtXC.setAttribute({strokeColor: '#FF3B3B'});
    txtYC.setAttribute({strokeColor: '#FF3B3B'});
    ptC.label.setAttribute({strokeColor: '#FF3B3B'});
});

txtYC2.on('out', function () {
    txtXC.setAttribute({strokeColor: '#000'});
    txtYC.setAttribute({strokeColor: '#000'});
    ptC.label.setAttribute({strokeColor: '#000'});
});

brd1.unsuspendUpdate();
}
}
export default Boxes;
